import React, {PureComponent} from "react";
import PropTypes from "prop-types";
import {Select, Button, Row, Col} from "antd";

import {BaseComponent, request} from '@cm-sites-webber/components';

import './style.css';
import FormItem from "../formItem";
import {PositionTypeContext} from "../../PositionAdd";
import {uuid} from "../../../../../../utils";
// 获取antd Select属性
const InputProps = {
    onChange: () => {
    }, ...Select.defaultProps, ...Select.propTypes
}

/**
 * Select输入框
 */
class RmtDangerDisposer extends BaseComponent {
    constructor(props) {
        super(props);

        this.state = {
            fieldProps: {},
            suffixWidth: 0,
            options: [],
            value: '',
            loading: false,
            fixedFieldConfig: []
        };
        this.setData(false);
    }

    componentDidMount() {
        const observer = new ResizeObserver((e, o) => {
            this.setState({
                suffixWidth: e[0].contentRect.width + 5 + 32,  //添加间距
            })
        });
        const suffixDom = document.querySelector(`div[data-name ='${this.props.name}'] .rmt-input-suffix-layout`);
        if (suffixDom) {
            observer.observe(suffixDom);
        }
        this.getMainDutyDeptInitData();
        this.updateValue();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.fieldProps.disabled !== prevProps.fieldProps.disabled) {
            this.setData(true)
        }
    }

    componentWillUnmount() {
        // 解决异常组件卸载调用setState
        this.setState = () => {
        }
    }

    static getDerivedStateFromProps(props, state) {
        // 判断props中的属性
        if (props.fieldProps && state !== props.fieldProps) {
            let newProps = {};
            for (const key in props) {
                if (!Object.hasOwnProperty.call(RmtDangerDisposer.defaultProps, key)) {
                    newProps[key] = props[key];
                }
            }
            for (const fieldKey in props.fieldProps) {
                if (Array.isArray(props.fieldProps?.extra) && !props.fieldProps?.extra.includes(fieldKey)) {
                    newProps[fieldKey] = props.fieldProps[fieldKey];
                }
            }
            return {...state, fieldProps: {...newProps}}
        }
        return state
    }

    renderSuffixButton() {
        const {buttonProps = {}} = this.props.fieldProps;
        return (
            <>
                <Button {...buttonProps}>{buttonProps?.name}</Button>
            </>
        )
    }

    getData() {
        let data = [];
        this.state.fixedFieldConfig.map((firstItem, firstIndex) => {
            // 只有userId存在才传进去
            if (firstItem.find((i) => i.labelCode === 'userId').value) {
                data.push({
                    userId: firstItem.find((i) => i.labelCode === 'userId').value || "",
                    userNumber: firstItem.find((i) => i.labelCode === 'userNumber').value || "",
                    userEmail: firstItem.find((i) => i.labelCode === 'userEmail').value || "",
                    userInfo: firstItem.find((i) => i.labelCode === 'userId').userInfo || "",
                })
            }
        })
        this.props.fieldProps.onChange(data, null, this.state.fixedFieldConfig);
    }

    setData(setState) {
        const {value} = this.props.fieldProps;
        let fixedFieldConfig = [];
        if (value && value.length) {
            value.map((item, index) => {
                fixedFieldConfig.push(this.fixedFieldConfigFun(item))
            })
        } else {
            fixedFieldConfig.push(this.fixedFieldConfigFun())
        }
        this.state.fixedFieldConfig = fixedFieldConfig;
        setState && this.setState({})
    }

    fixedFieldConfigFun = (data = {}) => {
        return [
            {
                col: 12,
                componentType: "disposer", // UI类型
                key: data?.userInfo?.key || uuid(),
                id: "userId", // 标签id
                labelName: "危险处置人", // 标签名
                labelCode: "userId", // 标签key
                value: data.userId || "", // 值所在位置
                userInfo: data.userInfo || "",
                required: false, // 是否必填
                fieldProps: {
                    placeholder: "请搜索危险处置人", // 空输入框提示
                    message: "请选择危险处置人", // 校验提示
                    size: "default", // 标签大小
                    disabled: false, // 是否禁用,
                },
            },
            {
                col: 12,
                componentType: "input", // UI类型
                value: data.userNumber || "", // 值所在位置
                labelName: "处置人手机号码", // 标签名
                labelCode: "userNumber", // 标签key
                required: false, // 是否必填
                id: "userNumber", // 标签id
                fieldProps: {
                    placeholder: "请输入处置人手机号码", // 空输入框提示
                    message: "请输入处置人手机号码", // 校验提示
                    size: "default", // 标签大小
                    disabled: false, // 是否禁用
                }
            },
            {
                col: 12,
                componentType: "input", // UI类型
                value: data.userEmail || "", // 值所在位置
                labelName: "处置人邮箱", // 标签名
                labelCode: "userEmail", // 标签key
                required: false, // 是否必填
                id: "userEmail", // 标签id
                fieldProps: {
                    placeholder: "请输入处置人邮箱", // 空输入框提示
                    message: "请输入处置人邮箱", // 校验提示
                    size: "default", // 标签大小
                    disabled: false, // 是否禁用
                }
            }
        ]
    }

    renderFields() {
        if (!(this.state.fixedFieldConfig && this.state.fixedFieldConfig.length)) return null;
        return this.state.fixedFieldConfig.map((firstItem, firstIndex) => {
            return <Col key={firstItem[0].key} span={24}>{this.renderFirstField(firstItem, firstIndex)}</Col>
        })
    }

    renderFirstField(firstItem, firstIndex) {
        return firstItem.map((secondItem, secondIndex) => {
            return this.renderSecondField(secondItem, firstIndex, secondIndex)
        })
    }

    addDangerDisposer = () => {
        this.state.fixedFieldConfig.push(this.fixedFieldConfigFun())
        this.setState({}, () => {
            this.getData();
        })
    }

    delDangerDisposer = (firstIndex) => {
        const newArray = [...this.state.fixedFieldConfig];
        newArray.splice(firstIndex, 1);
        this.setState({
            fixedFieldConfig: newArray
        }, () => {
            this.getData();
        })
    }

    onInformationChange = ({val, firstIndex, secondIndex, labelCode}) => {
        if (labelCode === 'userId' && val && typeof val === 'object') {
            this.state.fixedFieldConfig[firstIndex][secondIndex].value = val.userId;
            this.state.fixedFieldConfig[firstIndex][secondIndex].userInfo = val;
        } else {
            this.state.fixedFieldConfig[firstIndex][secondIndex].value = val;
        }
        this.setState({}, () => {
            this.getData();
        });
    };

    renderSecondField = ({
                             componentType = "input",
                             value = undefined,
                             userInfo = {},
                             labelCode = "",
                             labelName = "未知",
                             required = false,
                             id = `position_${labelCode}`,
                             col = 12,
                             fieldProps = {},
                             options = {}
                         }, firstIndex, secondIndex) => {

        let onFieldsChange = (val) => {
            this.onInformationChange({val, firstIndex, secondIndex, labelCode})
        };
        const {disabled, isUpdateInfo} = this.props.fieldProps;
        return (
            <Col span={col} key={id} className={"dangerDisposerFieldsCol"}>
                <FormItem
                    formKey={labelCode}
                    itemType={componentType}
                    label={labelName}
                    fieldProps={{
                        ...fieldProps,
                        value: value,
                        userInfo: userInfo,
                        onChange: onFieldsChange,
                        addDangerDisposer: this.addDangerDisposer,
                        delDangerDisposer: () => this.delDangerDisposer(firstIndex),
                        firstIndex: firstIndex,
                        disabled: disabled,
                        isUpdateInfo
                    }}
                    required={required}
                    hasFeedback={true}
                    setValidatedStatus={true}
                    options={
                        {
                            ...options
                        }
                    }
                />
                <style>{`.dangerDisposerFieldsCol{padding: 0 10px;}`}</style>
            </Col>
        )
    };

    render() {
        const {style = {},} = this.props.fieldProps;
        const {fieldProps, suffixWidth, value, options, loading} = this.state;
        const newValue = value && Array.isArray(options) && options.length ? value : undefined
        return (
            <>
                <PositionTypeContext.Consumer>
                    {
                        value => (
                            <Row>
                                {this.renderFields()}
                            </Row>
                        )
                    }
                </PositionTypeContext.Consumer>
            </>
        )
    }

    /**
     * 初始化主责单位
     **/
    getMainDutyDeptInitData() {
        this.setState({
            loading: true,
        })
        request({
            url: "/cm-sites-sys/dept/getDeptAndSon",
            body: ["0"],
            method: "post",
            contentType: "json",
            callBack: (response) => {
                if (response) {
                    if (response && response.length > 0) {
                        this.setState({
                            options: response,
                            loading: false,
                        })
                    }
                }
            }
        })
    }

    // 更新组件内部value
    updateValue(refreshData) {
        if (refreshData) {
            const updateStack = {};
            for (const item of refreshData) {
                if (Object.keys(this.props.fieldProps).includes(item)) {
                    updateStack[item] = this.props.fieldProps[item];
                }
            }
            this.setState({...updateStack})
        } else {
            this.setState({
                value: this.props.fieldProps.value,
            })
        }
    }

}

export default RmtDangerDisposer;

RmtDangerDisposer.propTypes = {
    suffixButton: PropTypes.bool,
    prefixLayout: PropTypes.node,
    suffixLayout: PropTypes.node,
    style: PropTypes.object,
    fieldProps: PropTypes.object,
}

RmtDangerDisposer.defaultProps = {
    style: {},
    fieldProps: {
        options: [],
    },
    setFiledValidateStatus: () => {
    }
}